// Add indiv scroll to top icon at bottom of page while scrolltop is bigger than 300px.
// The button disappears after a few seconds not scrolling - letting the user focus on content - but
// reappears on scroll

const hideScrollTopAfterNoScroll = window.Foundation.util.debounce(() => {
  $('[data-scroll-to-top]').fadeOut();
}, 3000);

$(document).ready(() => {
  $(window).scroll(function () {
    if ($(this).scrollTop() > 300) {
      $('[data-scroll-to-top]').css('display', 'flex').fadeIn('fast');
      hideScrollTopAfterNoScroll();
    } else {
      $('[data-scroll-to-top]').fadeOut('fast');
    }
  });

  $('[data-scroll-to-top]').click(() => {
    $('html, body').animate({ scrollTop: 0 }, 500);
  });
});
